import { Injectable } from '@angular/core';
import { NavigationDropdown, NavigationItem, NavigationLink, NavigationSubheading } from '../interfaces/navigation-item.interface';
import { BehaviorSubject, Subject } from 'rxjs';
import { PermissionService } from 'src/app/services/permissionservice.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private _itemsSubject = new BehaviorSubject<NavigationItem[]>([]);
  items$ = this._itemsSubject.asObservable();
  
  isloadingSideBar = false;

  private _openChangeSubject = new Subject<NavigationDropdown>();
  openChange$ = this._openChangeSubject.asObservable();

  constructor(private permissionService: PermissionService) {}

  getItems() {
    this.isloadingSideBar = true;
    this.permissionService.mountMenu().subscribe((res) => {
      this.isloadingSideBar = false;
      console.log("Menu items", res);
      this._itemsSubject.next(res);
    });
  }

  triggerOpenChange(item: NavigationDropdown) {
    this._openChangeSubject.next(item);
  }

  isLink(item: NavigationItem): item is NavigationLink {
    return item.type === 'link';
  }

  isDropdown(item: NavigationItem): item is NavigationDropdown {
    return item.type === 'dropdown';
  }

  isSubheading(item: NavigationItem): item is NavigationSubheading {
    return item.type === 'subheading';
  }
}
